<template>
  <div>
    <v-card-title>
      <v-row>
        <v-col cols="11">
          <simple-search :searchFunction="pesquisar" />
        </v-col>
      </v-row>
    </v-card-title>
    <v-skeleton-loader
      :loading="loading"
      transition="scale-transition"
      height="94"
      type="list-item-three-line"
    >
      <v-col>
        <BaseDataTable
          pagination
          justifyPagination="center"
          :item-class="setRowClass"
          :headers="pendingHeaders"
          :items="processosPendentes"
          :length="pagesPendencia()"
          :page="pagePendencia"
          @paginate="pagePendencia = $event"
          @onEdit="redirectGFS($event, 'edit')"
          @onView="redirectGFS($event, 'view')"
        >
          <template v-slot:[`item.status`]="{ item }">
            <v-row>
              <v-col cols="auto">
                <v-icon x-large class="status">
                  {{ item.icone }}
                </v-icon>
              </v-col>
              <v-col cols="auto">
                <span class="d-block">{{ item.nm_etapa_processo }}</span>
                <span class="font-weight-bold status">{{
                  item.nm_situacao
                }}</span>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.nm_usuario_solicitante`]="{ item }">
            <span style=" font-weight: 500; font-size: 12px;">
              {{ item.nm_usuario_solicitante }}
            </span>
          </template>
          <template v-slot:[`item.vl_solicitacao`]="{ item }">
            {{ filterVlSolicitacao(item.vl_solicitacao) }}
          </template>
          <template v-slot:[`item.dt_inicio_servico`]="{ item }">
            {{ formataData(item.dt_inicio_servico) }}
          </template>
          <template v-slot:[`item.dt_fim_servico`]="{ item }">
            {{ formataData(item.dt_fim_servico) }}
          </template>
        </BaseDataTable>
      </v-col>
    </v-skeleton-loader>
  </div>
</template>
<script>
import BaseDataTable from "../../../components/UI/BaseDataTable";
import SimpleSearch from "../../../components/UI/SimpleSearch";
import { VMoney } from "v-money";
import { mapGetters, mapActions } from "vuex";
import store from "../_store";
import { mask } from "vue-the-mask";
import JWT from "../../../api/jwt";
import _ from "lodash";

export default {
  components: {
    BaseDataTable,
    "simple-search": SimpleSearch
  },
  directives: { money: VMoney, mask },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      page: 1,
      pagePendencia: 1,
      processosPendentes: [],
      filters: {},
      menu: false,
      termoDeBusca: "",
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      isFilterAdvanced: false,
      headers: [
        {
          value: "actions",
          actions: [
            {
              type: "button",
              click: "onView",
              icon: "icon-eye",
              options: { fab: true, icon: true, small: true }
            }
          ]
        },
        { text: "Nº do processo", value: "cd_processo" },
        { text: "Cód. Fornecimento", value: "nm_codigo_fornecimento" },
        { text: "Tipo do processo", value: "tipo_processo.nm_tipo_processo" },
        { text: "Solicitante", value: "solicitantes.nm_usuario" },
        {
          text: "Valor da solicitação",
          value: "valor"
        },
        { text: "Data de Previsão de Pagamento", value: "" },
        { text: "Status", value: "status" }
      ],
      pendingHeaders: [
        {
          value: "actions",
          actions: [
            {
              type: "button",
              click: "onEdit",
              icon: "icon-pencil",
              options: { fab: true, icon: true, small: true }
            },
            {
              type: "button",
              click: "onView",
              icon: "icon-eye",
              options: { fab: true, icon: true, small: true }
            }
          ],
          width: "120px"
        },
        { text: "Nº do processo", value: "cd_processo" },
        {
          text: "Tipo do processo",
          value: "nm_tipo_processo",
          width: "20%"
        },
        { text: "Solicitante", value: "nm_usuario_solicitante", width: "15%" },
        { text: "Prestação do início do serviço", value: "dt_inicio_servico" },
        { text: "Prestação do fim do serviço", value: "dt_fim_servico" },
        {
          text: "Valor da solicitação",
          value: "vl_solicitacao"
        },
        { text: "Status", value: "status", width: "20%" }
      ],
      currentTab: "finalizados"
    };
  },

  computed: {
    ...mapGetters({
      processes: "$_process/processes",
      processTypes: "$_process/processTypes",
      processStatus: "$_process/processStatus",
      departaments: "$_process/departaments",
      me: "$_auth/me"
    }),
    // processosPendentes() {
    //   const processos = this.processes.processosPendentes || [];
    //   return processos.slice(
    //     (this.pagePendencia - 1) * 10,
    //     this.pagePendencia * 10
    //   );
    // },
    view() {
      return this.$can("edit");
    }
  },

  watch: {
    processes: {
      handler(val) {
        const processos = val.processosFinalizados.data || [];
        this.processosPendentes = processos;
        // .slice(
        //   (this.pagePendencia - 1) * 15,
        //   this.pagePendencia * 15
        // );
      },
      deep: true
    },
    pagePendencia() {
      this.getProcess(this.pagePendencia);
    }
  },

  beforeCreate() {
    const STORE_AUTH = "$_process";

    if (!(STORE_AUTH in this.$store._modules.root._children))
      this.$store.registerModule(STORE_AUTH, store);
  },

  async created() {
    // await this.getProcess();
    // await this.getProcessTypes();
    // await this.getProcessStatus();
    // await this.getDepartaments();
  },

  methods: {
    async redirectGFS(item, type) {
      if (!_.hasIn(this.me, "tokenGfs")) {
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: `Não foi possível acessar o processo no momento. Por favor, tente novamente.`,
          type: "error",
          title: "Error!",
          timeout: 8000
        });
        return false;
      }

      if (type === "edit") {
        let url = `${process.env.VUE_APP_GFS_URL}processos/${
          item.cd_processo
        }/editar?token_pfo=${JWT.getToken()}&token_gfs=${
          this.me.tokenGfs
        }&back=${this.$route.path.slice(1)}`;
        window.location.replace(url);
      } else {
        let url = `${process.env.VUE_APP_GFS_URL}processos/${
          item.cd_processo
        }/visualizar?token_pfo=${JWT.getToken()}&token_gfs=${
          this.me.tokenGfs
        }&back=${this.$route.path.slice(1)}`;
        window.location.replace(url);
      }
    },
    async handlerUniversalFilter() {
      let newFilter = {};
      Object.entries(this.filters).forEach(element => {
        if (element[1]) {
          newFilter[element[0]] = element[1];
        }
      });

      await this.$router.replace({ name: "process.index", query: newFilter });
      await this.getProcess();
    },
    async getProcess(page) {
      this.page = page || 1;
      this.loading = true;
      await this.listProvider({
        page: this.page,
        pesquisa: this.termoDeBusca,
        type: this.currentTab
      });
      this.loading = false;
    },
    async handlerSearch() {
      let newFilter = {};
      Object.entries(this.filters).forEach(element => {
        if (element[1]) {
          newFilter[element[0]] = element[1];
        }
      });

      await this.$router.replace({ name: "process.index", query: newFilter });
      await this.getProcess();
    },
    async handlerErase() {
      Object.entries(this.filters).forEach(element => {
        this.filters[element[0]] = "";
      });

      await this.$router.replace({ name: "process.index" });
      await this.getProcess();
    },
    setRowClass(item) {
      switch (item.nm_situacao.toLowerCase()) {
        case "aguardando":
        case "corrigido":
        case "redirecionado":
          return "aguardando-status";
        case "em andamento":
          return "andamento-status";
        case "aprovado":
          return "aprovado-status";
        case "retornado para correção":
          return "correcao-status";
        default:
          return "default-status";
      }
    },
    filterVlSolicitacao(item) {
      if (item === 0) return "";

      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(item);
    },
    pagesPendencia() {
      const processos = this.processes.processosFinalizados.total;
      return Math.ceil(
        processos / this.processes.processosFinalizados.per_page
      );
    },
    formataData(data) {
      if (data) {
        return new Date(data).toLocaleDateString("pt-BR");
      }
      return "Data não informada";
    },
    async pesquisar(termoDeBusca, params) {
      this.termoDeBusca = termoDeBusca;
      let query = { pesquisa: termoDeBusca, ...params };
      Object.keys(query).forEach(key => {
        if (!query[key]) {
          delete query[key];
        }
      });
      await this.getProcess();
    },
    ...mapActions({
      listProvider: "$_process/index",
      getProcessTypes: "$_process/getProcessTypes",
      getProcessStatus: "$_process/getProcessStatus",
      getDepartaments: "$_process/getDepartaments"
    })
  }
};
</script>
<style></style>
